import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { scheduleApi, ScheduleSlotCreate, ScheduleSlotUpdate } from "@/api/schedule";

export function useSchedule(deviceId: string | undefined) {
  return useQuery({
    queryKey: ["schedule", deviceId],
    queryFn: () => scheduleApi.list(deviceId!),
    enabled: !!deviceId,
  });
}

export function useCreateSlot(deviceId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ScheduleSlotCreate) => scheduleApi.create(deviceId, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["schedule", deviceId] }),
  });
}

export function useUpdateSlot(deviceId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ slotId, body }: { slotId: number; body: ScheduleSlotUpdate }) =>
      scheduleApi.update(deviceId, slotId, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["schedule", deviceId] }),
  });
}

export function useDeleteSlot(deviceId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (slotId: number) => scheduleApi.delete(deviceId, slotId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["schedule", deviceId] }),
  });
}
